import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import api from '../lib/api';
import useSiteBootstrap from '../hooks/useSiteBootstrap';
import { useToast } from '../components/common/ToastProvider';
import '../styles/ai-theme.css';

export default function SignupPage() {
  const navigate = useNavigate();
  const site = useSiteBootstrap();
  const { showToast } = useToast();
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const signup = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      await api.post('/accounts/signup/', form, { headers: { 'X-Bypass-Auth': '1' } });
      setMsg('Signup successful. Please login.');
      showToast('Signup successful. Please login.', 'success');
      setTimeout(() => navigate('/login'), 1200);
    } catch (e2) {
      const errorMessage = e2?.response?.data?.error || 'Signup failed';
      setErr(errorMessage);
      showToast(errorMessage, 'danger');
    }
  };

  const googleSignup = async () => {
    const idToken = window.prompt('Paste Google ID token to continue');
    if (!idToken) return;
    try {
      const { data } = await api.post('/accounts/google-login/', { id_token: idToken }, { headers: { 'X-Bypass-Auth': '1' } });
      localStorage.setItem('access', data.access);
      localStorage.setItem('refresh', data.refresh);
      window.location.href = data.user?.is_staff || data.user?.is_superuser ? '/admin' : '/dashboard';
    } catch (e2) {
      const errorMessage = e2?.response?.data?.error || 'Google signup/login failed';
      setErr(errorMessage);
      showToast(errorMessage, 'danger');
    }
  };

  return (
    <div className="ai-scope"><div className="ai-bg"><div className="center-screen"><Container className="card-fixed"><Card className="glass-card p-3">
      <div className="glass-header d-flex align-items-center justify-content-between"><h4 className="h-title m-0">Create account</h4><span className="badge-soft">Get Started</span></div>
      <div className="p-3">
        {msg && <Alert variant="success">{msg}</Alert>}
        {err && <Alert variant="danger">{err}</Alert>}
        <Form onSubmit={signup} className="d-grid gap-3">
          <Form.Control className="input-ai" placeholder="Username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required />
          <Form.Control className="input-ai" placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <Form.Control className="input-ai" placeholder="Password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          <Button type="submit" className="btn-ai w-100">Sign up</Button>
          {site?.settings?.google_enabled && (
            <Button type="button" variant="outline-light" className="w-100" onClick={googleSignup}>Continue with Google</Button>
          )}
          <Button type="button" className="btn-ai-ghost w-100" onClick={() => navigate('/login')}>I already have an account</Button>
        </Form>
      </div>
    </Card></Container></div></div></div>
  );
}
